import { GREY_300 } from '@mnd-frontend/ui';
import styled from 'styled-components';

export const ReportBackground = styled.div<{ $brandColor?: string | null }>`
  background: ${GREY_300};
  padding: 2rem;
  --coverage-brand-color: ${props => props.$brandColor || '#000'};
`;
